import React from 'react';
interface CalendarEventCardProps {
  patientName: string;
  examType: string;
  doctor: string;
  time: string;
  colorClass?: string;
  className?: string;
  onClick?: () => void;
}
export function CalendarEventCard({
  patientName,
  examType,
  doctor,
  time,
  colorClass = 'border-medical-green',
  className = '',
  onClick
}: CalendarEventCardProps) {
  return <div onClick={onClick} className={`bg-white border-l-4 ${colorClass} rounded-r-md shadow-sm p-2 text-left flex flex-col ${onClick ? 'cursor-pointer hover:shadow-md transition-shadow' : ''} ${className}`} data-id="element-187">
      <div className="text-xs font-medium text-text-secondary mb-0.5 shrink-0" data-id="element-188">
        {time}
      </div>
      <div className="text-sm font-semibold text-text-primary" data-id="element-189">
        {patientName}
      </div>
      <div className="text-xs text-text-secondary" data-id="element-190">{examType}</div>
      <div className="text-xs text-text-tertiary mt-auto pt-1" data-id="element-191">{doctor}</div>
    </div>;
}